import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { decryptText } from '../../utils/utils';
import { Permission } from '../../utils/dto/response';

type PermissionState = Permission & {
    isOpen: boolean;
};

let permissions: Permission = { roles: [], menus: [], sidemenu:[] };
try {
    const encrypted = localStorage.getItem('roles_permissions');
    if (encrypted) {
        permissions = JSON.parse(decryptText(encrypted));
    }
} catch (e) {
    console.error('Failed to load permissions:', e);
}

const initialState: PermissionState = {
    roles: permissions.roles ?? [],
    menus: permissions.menus ?? [],
    sidemenu: permissions.sidemenu ?? [],
    isOpen: false,
};

const permissionSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermission: (state, action: PayloadAction<Partial<PermissionState>>) => {
            Object.assign(state, action.payload, { isOpen: true });
        },
        clearPermission: () => ({
            roles: [],
            menus: [],
            sidemenu:[],
            isOpen: false,
        }),
    },
});

export const { setPermission, clearPermission } = permissionSlice.actions;
export default permissionSlice.reducer;
